// @flow

import _ from 'lodash';

// TODO: SDK
// import ViewConstants from '../constants/ViewConstants';

import PhoneUtils from './PhoneUtils';
import CurrencyUtils from './CurrencyUtils';

import { deprecated, log } from '../decorators';

export default class ViewUtils {

  @deprecated
  static formatPriceWithCurrency(price: number, currency: string): string {
    return CurrencyUtils.formatPriceWithCurrency(price, currency);
  }

  @deprecated
  static formatPrice(price: number): number {
    return CurrencyUtils.formatPrice(price);
  }

  @deprecated
  static formatTax(tax: number) {
    return CurrencyUtils.formatTax(tax);
  }

  static cutString(str: string, length: number): string {
    if (_.isUndefined(str) || _.isNull(str)) {
      return '';
    }
    let res = str.substring(0, length);
    if (str.length > length) {
      res += '...';
    }
    return res;
  }

  static isValidColor(color: string): boolean {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);
  }

  static isVeryLightColor(color: string) {
    return this.getHsp(color) > 230;
  }

  static isLightColor(color: string): boolean {
    return this.getHsp(color) > 190;//127.5;
  }


  static isDarkColor(color: string): boolean {
    return !this.isLightColor(color);
  }

  static getHsp(color: string): number {
    let validColor = color;
    // handle is not hexa color but uint.
    if (!isNaN(parseInt(color, 10))) {
      validColor = this.uintColorToHexadecimal(color);
    } else if (_.isNull(color) || _.isEmpty(color)) {
      console.error('invalid color string', color);
      return 360 / 2; // median
    }

    const rgbColor = this.hexadecimalColorToRgba(validColor);
    const r = rgbColor.r;
    const b = rgbColor.b;
    const g = rgbColor.g;

    const hsp = Math.sqrt( // HSP equation from http://alienryderflex.com/hsp.html
      0.299 * (r * r) +
      0.587 * (g * g) +
      0.114 * (b * b)
    );

    return hsp;
  }

  // -- Color conversion

  /**
   * see http://stackoverflow.com/questions/57803/how-to-convert-decimal-to-hex-in-javascript
   * @param color
   * @returns {String}
   */
  static uintColorToHexadecimal(color: number): string {
    return '#' + ('000000' + (color & 0xFFFFFF).toString(16)).slice(-6);
  }

  static rgbaToUint(rgba: Object) {
    // TODO: alpha value does not work here.
    return rgba.a << 24 | rgba.r << 16 | rgba.g << 8 | rgba.b;
  }

  static hexadecimalColorToUint(hex: string, opacity: number = 1) {
    const rgba = this.hexadecimalColorToRgba(hex, opacity);
    return this.rgbaToUint(rgba);
  }

  static hexadecimalColorToRgba(hex: string, opacity: number = 1): Object {
    if (_.isEmpty(hex)) {
      return {
        r: 0,
        g: 0,
        b: 0,
        a: 1
      };
    }
    if (hex[0] !== '#') { // in case we pass a uint value.
      return hex;
    }
    const hexString = hex.replace('#', '');
    const r = parseInt(hexString.substring(0, 2), 16);
    const g = parseInt(hexString.substring(2, 4), 16);
    const b = parseInt(hexString.substring(4, 6), 16);

    return {
      r,
      g,
      b,
      a: opacity
    };
  }

  static hexadecimalColorToRgbaCssFormat(hex: string, opacity: number = 1) {
    const rgba = this.hexadecimalColorToRgba(hex, opacity);
    return `rgba(${rgba.r},${rgba.g},${rgba.b},${rgba.a})`;
  }

  static uintToRgba(color: number): Object {
    const a = color >> 24 & 255;
    const r = color >> 16 & 255;
    const g = color >> 8 & 255;
    const b = color >> 0 & 255;

    return {
      r,
      g,
      b,
      a
    };
  }

  static uintColorToRgbaFormat(value: number) {
    const rgba = this.uintToRgba(value);
    return `rgba(${rgba.r},${rgba.g},${rgba.b},${rgba.a})`;
  }

  // --

  // TODO: SDK
  // static getDefaultColorListUint() {
  //   const hexList = ViewConstants.ColorPicker.DEFAULT_COLORS_LIST;
  //   const uintList = [];
  //
  //   _.each(hexList, (hexValue) => {
  //     uintList.push(ViewUtils.hexadecimalColorToUint(hexValue));
  //   });
  //
  //   return uintList;
  // }

  // -- Images

  /**
   * Transform a base64 string to a file.
   * see http://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata
   * @param dataUri
   */
  static dataUriToFile(dataUri: string): string {
    if (_.isNull(dataUri) || _.isUndefined(dataUri)) {
      console.error('invalid data uri to transform to file');
      return new Blob([], { type: 'picture/png' });
    }
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString;
    if (dataUri.split(',')[0].indexOf('base64') >= 0) {
      byteString = atob(dataUri.split(',')[1]);
    } else {
      byteString = unescape(dataUri.split(',')[1]);
    }

    // separate out the mime component
    const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  static fileToDataUri(file: File, callback: Function) {
    const reader = new FileReader();

    reader.addEventListener('load', function() {
      // the result attribute contains  the data as a URL representing the file's data as a base64 encoded string
      callback(reader.result);
    }, false);

    reader.readAsDataURL(file);
  }

  static resizeBase64Img(base64, width: number, height: number) {
    const deferred = $.Deferred();

    function resize() {
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext('2d');

      // in case we receive a dataUri instead of a base64.
      const realBase64 = ViewUtils.dataUriToBase64(base64);

      $('<img/>').attr('src', 'data:image/png;base64,' + realBase64).on('load', function() {
        if (!_.isNil(context)) {
          context.drawImage(this, 0, 0, width, height);
        }
        deferred.resolve(canvas.toDataURL());
      });
    }

    resize();

    return deferred.promise();
  }

  static resizeCanvasImg(canvas, width: number, height: number) {
    return ViewUtils.resizeBase64Img(canvas.toDataURL(), width, height);
  }

  static dataUriToBase64(dataURL: string): string {
     return dataURL.replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, '');
  }

  /*
   * @returns
   * true  - if page is currently using the breakpoint specified as argument
   * false - if otherwise
   */
  static isBreakpoint(alias: ResponsiveBreakpoint): boolean {
    const className = 'device-breakpoint';
    const testingDiv = `
      <div class='${className}'><!-- mandatory -->
      <div class="device-xs visible-xs"></div>
      <div class="device-sm visible-sm"></div>
      <div class="device-md visible-md"></div>
      <div class="device-lg visible-lg"></div>
      <!-- end mandatory --></div>
    `;

    if (!$('body').find(`.${className}`).length) {
      $('body').append(testingDiv);
    }

    const result = $('.device-' + alias).is(':visible');

    return result;
  }
}
